import { useState } from 'react';
import { Shopkeeper } from '../App';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from './ui/table';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Pencil, Trash2, Search } from 'lucide-react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from './ui/alert-dialog';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';



export function ShopkeeperList({
  shopkeepers,
  onEdit,
  onDelete,
}) {
  const [searchTerm, setSearchTerm] = useState('');
  const [deleteId, setDeleteId] = useState(null);

  const filteredShopkeepers = shopkeepers.filter(
    (shopkeeper) =>
      shopkeeper.shop_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      shopkeeper.contact_person.toLowerCase().includes(searchTerm.toLowerCase()) ||
      shopkeeper.mobile.includes(searchTerm) ||
      shopkeeper.city.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleDelete = () => {
    if (deleteId) {
      onDelete(deleteId);
      setDeleteId(null);
    }
  };

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <CardTitle>Shopkeeper List</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center gap-2 mb-4">
            <Search className="h-4 w-4 text-gray-500" />
            <Input
              placeholder="Search shopkeepers..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          {filteredShopkeepers.length === 0 ? (
            <div className="text-center py-12 text-gray-500">
              {searchTerm ? 'No shopkeepers found matching your search.' : 'No shopkeepers added yet.'}
            </div>
          ) : (
            <div className="space-y-4">
              <div className="rounded-md border overflow-auto">
                <Table>
                  <TableHeader>
                    <TableRow>
                      <TableHead>Shop Name</TableHead>
                      <TableHead>Contact Person</TableHead>
                      <TableHead>Mobile</TableHead>
                      <TableHead>City</TableHead>
                      <TableHead className="text-right">Actions</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {filteredShopkeepers.map((shopkeeper) => (
                      <TableRow key={shopkeeper.id}>
                        <TableCell>{shopkeeper.shop_name}</TableCell>
                        <TableCell>{shopkeeper.contact_person}</TableCell>
                        <TableCell>{shopkeeper.mobile}</TableCell>
                        <TableCell>{shopkeeper.city}</TableCell>
                        <TableCell className="text-right">
                          <div className="flex justify-end gap-2">
  
                            <Button
                              variant="ghost"
                              size="sm"
                              onClick={() => setDeleteId(shopkeeper.account_no)}
                            >
                              <Trash2 className="h-4 w-4 text-red-500" />
                            </Button>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>

              <div className="text-sm text-gray-600">
                Total: {filteredShopkeepers.length} shopkeeper(s)
              </div>
            </div>
          )}
        </CardContent>
      </Card>

      <AlertDialog open={!!deleteId} onOpenChange={() => setDeleteId(null)}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Are you sure?</AlertDialogTitle>
            <AlertDialogDescription>
              This action cannot be undone. This will permanently delete the
              shopkeeper record.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={handleDelete} className="bg-red-500 hover:bg-red-600">
              Delete
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
